import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { CalculatorStateService } from '@services/calculator-state.service';
import { CalculatorFlowService } from '@services/calculator-flow.service';
import { AuthService } from '@services/auth.service';
import { NAVIGATION_ROUTES } from '@shared/constants';

@Injectable({
  providedIn: 'root'
})
export class CalculatorFlowGuard implements CanActivate {
  private router = inject(Router);
  private calculatorStateService = inject(CalculatorStateService);
  private calculatorFlowService = inject(CalculatorFlowService);
  private authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const path = route.routeConfig?.path ?? '';

    if (path === 'calculator/confirm-materials') {
      return this.validateConfirmMaterialsAccess();
    }

    if (path === 'calculator/prelist') {
      return this.validatePrelistAccess();
    }

    // Ruta base: calculator (pasos 1-7 + successful-calculation)
    return this.validateCalculatorAccess();
  }

  /** Ruta /calculator — requiere que haya una sesión activa (workType en memoria) */
  private validateCalculatorAccess(): boolean {
    if (this.calculatorStateService.hasActiveSession()) {
      return true;
    }
    this.redirectToHome();
    return false;
  }

  /** Ruta /calculator/confirm-materials — requiere resultado de cálculo en memoria */
  private validateConfirmMaterialsAccess(): boolean {
    if (this.calculatorFlowService.currentCalculationResult()) {
      return true;
    }
    this.redirectToHome();
    return false;
  }

  /** Ruta /calculator/prelist — requiere preListId en memoria */
  private validatePrelistAccess(): boolean {
    if (this.calculatorFlowService.currentPreListId()) {
      return true;
    }
    this.redirectToHome();
    return false;
  }

  private redirectToHome(): void {
    const target = this.authService.isAuthenticated()
      ? NAVIGATION_ROUTES.INICIO
      : NAVIGATION_ROUTES.ROOT;
    this.router.navigate([target]);
  }
}
